import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { ref: "innerRef" }
const _hoisted_2 = { "txt-center": "" }
const _hoisted_3 = {
  "txt-center": "",
  "mt-2": ""
}
const _hoisted_4 = {
  "m-b-3": "",
  "txt-center": ""
}
const _hoisted_5 = { "txt-center": "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_app_business_stage_input = _resolveComponent("app-business-stage-input")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_app_skill_input = _resolveComponent("app-skill-input")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_dialog, {
      "custom-class": "App-Create-Business-Modal App-Unpadded",
      "model-value": _ctx.isModalOpen,
      width: "550px",
      "show-close": _ctx.showClose,
      "close-on-click-modal": _ctx.showClose,
      "close-on-press-escape": _ctx.showClose,
      onOpen: _ctx.opened,
      title: "Startup Next Stage",
      center: "",
      "append-to-body": true,
      "lock-scroll": true,
      "open-delay": 200,
      "before-close": _ctx.closeModal,
      "close-delay": 200
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_button, {
            "is-block": "",
            icon: "el-icon-check",
            onClick: _ctx.submit,
            size: "large",
            type: "primary",
            disabled: _ctx.disabledSave || _ctx.loading
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode(" Save ", -1)
            ]))]),
            _: 1
          }, 8, ["onClick", "disabled"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _withDirectives((_openBlock(), _createBlock(_component_el_scrollbar, {
            ref: "scrollbarRef",
            always: true,
            "max-height": "70vh"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_component_el_image, {
                        style: `width: 250px;`,
                        src: _ctx.img
                      }, null, 8, ["src"]),
                      _cache[2] || (_cache[2] = _createElementVNode("p", {
                        "m-rl-auto": "",
                        style: {"max-width":"350px"},
                        "txt-center": ""
                      }, [
                        _createTextVNode(" What is your next startup stage? "),
                        _createElementVNode("br"),
                        _createTextVNode(" What skills do you think you need to get there? ")
                      ], -1))
                    ])
                  ])
                ]),
                _createVNode(_component_el_form, {
                  onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
                  class: "App-Styled-Form",
                  "label-position": 'top',
                  "label-width": "100px",
                  model: _ctx.form,
                  style: {"margin-top":"12px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_app_business_stage_input, {
                      label: "Your startup's next stage",
                      modelValue: _ctx.form.nextStage,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.nextStage) = $event))
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_el_divider),
                    _createElementVNode("h4", _hoisted_3, " Select the skillsets needed to transition your startup " + _toDisplayString(_ctx.startupName) + " to the next stage, indicated above. ", 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.skillsNeeded, (skill, index) => {
                      return (_openBlock(), _createBlock(_component_el_row, {
                        align: "middle",
                        justify: "center",
                        key: `skill-input-${index}${skill.name}`
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, {
                            span: index == 0 ? 24 : 22
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_app_skill_input, {
                                "w-100": "",
                                modelValue: _ctx.form.skillsNeeded[index].name,
                                "onUpdate:modelValue": ($event: any) => ((_ctx.form.skillsNeeded[index].name) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 2
                          }, 1032, ["span"]),
                          (index !== 0)
                            ? (_openBlock(), _createBlock(_component_el_col, {
                                key: 0,
                                "txt-right": "",
                                span: 2
                              }, {
                                default: _withCtx(() => [
                                  (index > 0)
                                    ? (_openBlock(), _createBlock(_component_el_button, {
                                        key: 0,
                                        style: {"margin-bottom":"18px"},
                                        onClick: ($event: any) => (_ctx.removeSkill(index)),
                                        icon: "el-icon-delete",
                                        circle: "",
                                        size: "mini"
                                      }, null, 8, ["onClick"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128)),
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_el_button, {
                        class: "button-new-tag",
                        size: "small",
                        onClick: _ctx.addSkill,
                        round: "",
                        icon: "el-icon-plus"
                      }, {
                        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                          _createTextVNode(" Add Skill ", -1)
                        ]))]),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ]),
                  _: 1
                }, 8, ["model"])
              ], 512)
            ]),
            _: 1
          })), [
            [_directive_loading, _ctx.loading]
          ])
        ])
      ]),
      _: 1
    }, 8, ["model-value", "show-close", "close-on-click-modal", "close-on-press-escape", "onOpen", "before-close"])
  ]))
}